import * as React from "react";
import { useParams } from "react-router";
import { DownloadFile } from "./components/DownloadFile";

export const DownloadFileRoot: React.FC = () => {
  const params = useParams();
  const fileKey = params["fileKey"];
  return <DownloadFile fileKey={fileKey} />;
};
